export const SYNCED_VEHICLE_FIELDS = ["vehicleId", "year", "make", "model", "vin", "licensePlate", "odometer"] as const;

// The Vehicle tab updates the job's vehicle outside the Job form, so a field the form never touched must take the job's current value, not revert it.
export const withLatestVehicleFields = <T extends Partial<Record<typeof SYNCED_VEHICLE_FIELDS[number], unknown>>>(
  values: T,
  mounted: T,
  latest: T
): T =>
  SYNCED_VEHICLE_FIELDS.reduce(
    (next, field) => (values[field] === mounted[field] ? { ...next, [field]: latest[field] } : next),
    values
  );
